import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { GlobalErrorScreen } from './GlobalErrorScreen.tsx';

type Props = {
  children: React.ReactNode;
};

export const GlobalErrorBoundary = ({ children }: Props) => {
  return (
    <ErrorBoundary FallbackComponent={GlobalErrorScreen}>
      {children}
    </ErrorBoundary>
  );
};
